var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaper = function SvgPaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.035 11.459h-2.13v-7.02c0-1.37-1.119-2.489-2.525-2.489H3.964c-1.406 0-2.525 1.118-2.525 2.489v14.56c.062 1.49.427 2.505 1.01 3.146.585.643 1.382.905 2.291.905h15.52c.92 0 1.746-.573 2.34-1.36.593-.789.961-1.8.961-2.693v-5.37c0-.686-.28-1.23-.739-1.602-.457-.37-1.088-.566-1.787-.566Zm-3.784 9.668H4.741c-.735 0-1.355-.629-1.355-1.403V4.537c0-.331.263-.603.578-.603H16.38c.315 0 .578.272.578.603v15.187c0 .486.101.961.293 1.403Zm1.654-7.598h2.13c.316 0 .579.271.579.603v5.592c0 .774-.62 1.403-1.355 1.403-.734 0-1.354-.629-1.354-1.403v-6.195Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.336 10.04c0-.07.07-.128.151-.128h4.716c.082 0 .151.059.151.127 0 .069-.07.128-.15.128H9.486c-.081 0-.15-.06-.15-.128Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.204 10.647H9.486c-.405 0-.73-.274-.73-.618 0-.343.325-.617.73-.617h4.716c.406 0 .73.274.73.617 0 .344-.324.618-.73.618ZM6.024 13.464h8.48c.18 0 .31.126.31.273 0 .157-.143.272-.31.272h-8.48c-.178 0-.309-.126-.309-.272 0-.157.143-.273.31-.273Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.505 14.365H6.024c-.392 0-.7-.283-.7-.618s.32-.618.7-.618h8.48c.393 0 .702.283.702.618s-.321.618-.701.618Z",
    fill: "#58B847",
    stroke: "#58B847",
    strokeWidth: 0.4
  })));
};
export default SvgPaper;